import { useContext } from 'react';
import { Card, Field } from '../../../../layouts';
import { formatShortDate } from '../../../../utils/date-utils';
import { RetailOrderContext } from '../context/RetailOrderContext';

export default function CabinetOrderInformationCard() {

	const { order } = useContext(RetailOrderContext);

	return (
		<>
			<Card className='field-label-60' header={'Cabinet Order Information'}>
				<Field label={'Cabinet Order'} showCopyToClipboard={true} >{order.details.cabinetOrder.roNumber}</Field>
				<Field label={'Scheduled Completion Date'} >{formatShortDate(order.details.cabinetOrder.scheduledInstallCompletionDate)}</Field>
				<Field label={'Actual Completion Date'} >{formatShortDate(order.details.cabinetOrder.actualInstallCompletionDate)}</Field>
				<Field label={'Company Name'} >{order.details.cabinetOrder.installerCompanyName}</Field>
				<Field label={'Company Phone'} >{order.details.cabinetOrder.installerCompanyPhone}</Field>
				<Field label={'Contact'} >{order.details.cabinetOrder.installerContact}</Field>
			</Card>
		</>
	);
}
